type IconProps = {
	width?: number;
	height?: number;
};

export const CouponTicketIcon = ({ width = 26, height = 24 }: IconProps) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		stroke="#774A91"
		strokeWidth="1.9"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
		style={{ flexShrink: 0 }}
	>
		<path d="M3 7.5A1.5 1.5 0 0 1 4.5 6h15A1.5 1.5 0 0 1 21 7.5V10a2 2 0 0 0 0 4v2.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 16.5V14a2 2 0 0 0 0-4z" />
		<path d="M9.5 15l5-6" />
		<circle cx="9.5" cy="9.5" r=".8" />
		<circle cx="14.5" cy="14.5" r=".8" />
	</svg>
);

export const CouponCheckIcon = ({ width = 20, height = 20 }: IconProps) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 24 24"
		fill="none"
		aria-hidden="true"
		style={{ flexShrink: 0 }}
	>
		<circle cx="12" cy="12" r="11" fill="#774A91" />
		<path
			d="M7 12.5l3.2 3.2L17 8.8"
			stroke="#FFFFFF"
			strokeWidth="2.4"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const StrokeIcon = ({ path, color }: { path: string; color: string }) => (
	<svg
		width="18"
		height="18"
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth="2.6"
		strokeLinecap="round"
		strokeLinejoin="round"
		aria-hidden="true"
	>
		<path d={path} />
	</svg>
);

export const ArrowRightIcon = () => (
	<StrokeIcon path="M5 12h14M13 6l6 6-6 6" color="currentColor" />
);

export const ChevronRightIcon = () => <StrokeIcon path="M9 6l6 6-6 6" color="#2c2c2c" />;
